export default __webpack_public_path__ + "2350660a877ef4a1241dc0f5a7c90ba9.png";